import { render, staticRenderFns } from "./VersionDialog.vue?vue&type=template&id=fb6ab2fe&scoped=true"
import script from "./VersionDialog.vue?vue&type=script&lang=js"
export * from "./VersionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6ab2fe",
  null
  
)

export default component.exports